import { useQuery } from "@tanstack/react-query";
import useLocaleQueryFilter from "../../utils/useLocaleQueryFilter";
import { AttributeValue } from "./useAttributes";
import { ProductFilter } from "./useProduct";
import { ImageType } from "./useProducts";

export type VariantAttribute = Omit<AttributeValue, "sorting"> & {
  keySorting: number;
  valueSorting: number;
};

export type VariantType = {
  variantId: number;
  isDefault: boolean;
  productId: number;
  externalReference: string;
  quantity: number;
  attributes?: VariantAttribute[];
  defaultImage?: ImageType;
  localizedImage?: ImageType;
};

export default function useVariantsByProductId(filter: ProductFilter) {
  const localeFilter = useLocaleQueryFilter(filter);

  return useQuery<VariantType[], Error>(["variants/byproduct", localeFilter]);
}
